import React from 'react';
import { motion } from 'framer-motion';
import { Search, LayoutList, TrendingUp, Brain, Target, Zap } from 'lucide-react';
const phases = [{
  num: 1,
  title: 'DIAGNOSTICAR',
  desc: 'Descubrí exactamente dónde se está escapando tu dinero y cuáles son los errores que están frenando tu crecimiento.',
  icon: Search
}, {
  num: 2,
  title: 'ORGANIZAR',
  desc: 'Aprendé a ordenar ingresos, gastos y movimientos financieros para tener claridad total sobre tus números.',
  icon: LayoutList
}, {
  num: 3,
  title: 'MULTIPLICAR',
  desc: 'Conocé estrategias simples para aumentar ganancias y generar nuevas fuentes de ingresos.',
  icon: TrendingUp
}, {
  num: 4,
  title: 'REPROGRAMAR',
  desc: 'Eliminá hábitos financieros que limitan tu crecimiento y desarrollá una mentalidad orientada a resultados.',
  icon: Brain
}, {
  num: 5,
  title: 'PLANIFICAR',
  desc: 'Construí un plan financiero sólido para dejar de improvisar y empezar a crecer con dirección.',
  icon: Target
}, {
  num: 6,
  title: 'AUTOMATIZAR',
  desc: 'Implementá sistemas que te permitan mantener el control financiero de forma constante.',
  icon: Zap
}];
export function MethodPhases() {
  return <section className="py-24 bg-white" data-id="element-288">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-289">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-290">
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy-900 mb-4" data-id="element-291">
            EL MÉTODO DE 6 FASES
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-292">
            Un paso a paso estructurado para transformar el caos en control
            absoluto.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-293">
          {phases.map((phase, index) => {
          const Icon = phase.icon;
          return <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-[0_4px_20px_rgba(0,0,0,0.05)] border border-slate-100 relative overflow-hidden group hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-all duration-300" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-294">
                <div className="absolute -right-6 -top-6 text-9xl font-black text-slate-50 opacity-50 group-hover:scale-110 transition-transform duration-500 pointer-events-none" data-id="element-295">
                  {phase.num}
                </div>

                <div className="relative z-10" data-id="element-296">
                  <div className="w-14 h-14 bg-navy-50 rounded-xl flex items-center justify-center mb-6 text-navy-600 group-hover:bg-navy-900 group-hover:text-white transition-colors duration-300" data-id="element-297">
                    <Icon className="w-7 h-7" data-id="element-298" />
                  </div>

                  <div className="text-sm font-bold text-success mb-2 tracking-wider" data-id="element-299">
                    FASE {phase.num}
                  </div>
                  <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-300">
                    {phase.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-301">{phase.desc}</p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}